// Shared UI utilities

export function formatNumber(value) {
  if (value % 1 === 0) return value.toString();
  return value.toFixed(3).replace(/\.?0+$/, '');
}

export function attachCopyHandlers(root) {
  // kv-cards (entire card clickable)
  root.querySelectorAll('.kv-card[data-copy]').forEach(card => {
    const val = card.getAttribute('data-copy');
    card.addEventListener('click', () => copyWithTip(card, val));
    const copyIcon = card.querySelector('.kv-copy');
    if (copyIcon) {
      copyIcon.addEventListener('click', (e) => { e.stopPropagation(); copyWithTip(card, val); });
    }
  });
}

export async function copyWithTip(targetEl, value) {
  try {
    await navigator.clipboard.writeText(value);
  } catch (_) {}
  const tip = document.createElement('div');
  tip.className = 'kv-tip';
  tip.textContent = 'Copied';
  targetEl.appendChild(tip);
  setTimeout(() => { tip.remove(); }, 900);
}

